const Types = {
  Variant: "variant",
  Product: "product",
  Collection: "collection",
};

const freeGiftApp = {
  delimiters: ["${", "}"],
  data() {
    return {
      isActive: false,
      loading: false,
      freeGiftLoader: false,
      freeGiftData: null,
      freeGiftCookie: "",
      reload: false,
    };
  },
  watch: {
    isActive(value) {
      if (value) {
        document.querySelector("html").classList.add("t4s-modal-opened");
      } else {
        document.querySelector("html").classList.remove("t4s-modal-opened");
      }
    },
  },
  computed: {
    isNewFreeGiftAvailable() {
      try {
        let _is_available = false;

        if (
          this.freeGiftId &&
          this.freeGiftCookie !== this.freeGiftId &&
          this.freeGiftValues.id
        ) {
          _is_available = true;
        }

        return _is_available;
      } catch (e) {
        return false;
      }
    },
    freeGiftId() {
      return this.freeGiftData?.id;
    },
    freeGiftType() {
      return this.freeGiftData?.type;
    },
    freeGiftValues() {
      return this.freeGiftData?.values;
    },
    old_line_id() {
      return this.freeGiftData?.old_line_id;
    },
    is_narrow_width() {
      try {
        return (
          this.freeGiftType === Types.Variant ||
          this.freeGiftType === Types.Product ||
          false
        );
      } catch (e) {
        return false;
      }
    },
  },
  async created() {
    try {
      await this.checkFreeGift();
    } catch (e) {
      console.log("created error:", e);
    }
  },
  mounted() {
    this.bindEvents();
  },
  methods: {
    _limitProducts() {
      try {
        this.freeGiftValues.products = this.freeGiftValues.products?.filter(
          (_, index) => index < 9
        );

        const _length = this.freeGiftValues.products.length;

        if (_length < 9) {
          document
            .querySelector("#freeGift .l-freegift-collection")
            ?.classList.add(`l-${_length}-elements`);
        }
      } catch (e) {
        console.log("_limitProducts error:", e);
      }
    },
    async checkFreeGift() {
      try {
        this._startFreeGiftLoader();
        this.freeGiftCookie = this._getCookie("_free_gift_");

        const { data: freeGiftData } = await this.getFreeGiftData();
        this.freeGiftData = freeGiftData;

        if (this.freeGiftType === Types.Variant) {
          this.freeGiftValues.selectedVariant = this.freeGiftValues;
        } else if (this.freeGiftType === Types.Product) {
          this.freeGiftData.show &&
            (this.freeGiftValues.selectedVariant =
              this._getFirstAvailableVariant(this.freeGiftValues.variants));
        } else if (this.freeGiftType === Types.Collection) {
          if (this.freeGiftData.show) {
            this._limitProducts();

            this.freeGiftValues.products?.forEach((product) => {
              product.selectedVariant = this._getFirstAvailableVariant(
                product.variants
              );
              product.variants?.forEach((variant) => (variant.loading = false));
            });
          }
        }

        await this.deleteOldFreeGift();

        this._stopFreeGiftLoader();

        if (this.isNewFreeGiftAvailable) {
          if (this.freeGiftType === Types.Variant) {
            if (this._itemNotAvailableForSale(this.freeGiftValues)) {
              this.denyFreeGift();
            } else {
              this._showModal();
            }
          } else if (this.freeGiftType === Types.Product) {
            if (this._itemNotAvailableForSale(this.freeGiftValues)) {
              this.denyFreeGift();
            } else {
              this._showModal();
            }
          } else {
            this._showModal();
          }
        } else if (this.old_line_id) {
          this._setFreeGiftCookie();
          this._refresh();
        } else {
          this._setFreeGiftCookie();
        }
      } catch (e) {
        console.log("checkFreeGift error:", e);
      } finally {
        this._stopFreeGiftLoader();
      }
    },
    isDisabledOption(value, option, selectedVariant, variants) {
      let _is_disabled = false;

      if (
        !selectedVariant.selectedOptions.some(
          (item) => item.name === option.name && item.value === value
        )
      ) {
        let _variant_selected_options = [
          ...selectedVariant.selectedOptions,
        ].filter((opt) => opt.name !== option.name);

        _variant_selected_options = [
          ..._variant_selected_options,
          {
            name: option.name,
            value: value,
          },
        ];

        let notAvailableVariants = variants.filter(
          (variant) => !variant.availableForSale
        );

        _is_disabled = notAvailableVariants.some((variant) => {
          return this._arrayDeepEqual(
            variant.selectedOptions,
            _variant_selected_options
          );
        });
      }

      return _is_disabled;
    },
    _arrayDeepEqual(a, b) {
      const _length = a.length;

      if (_length === 1) {
        return a[0].name === b[0].name && a[0].value === b[0].value;
      } else if (_length === 2) {
        return (
          (a[0].name === b[0].name &&
            a[0].value === b[0].value &&
            a[1].name === b[1].name &&
            a[1].value === b[1].value) ||
          (a[0].name === b[1].name &&
            a[0].value === b[1].value &&
            a[1].name === b[0].name &&
            a[1].value === b[0].value)
        );
      } else {
        return false;
      }
    },
    _getFirstAvailableVariant(variants) {
      return variants.find((variant) => variant.availableForSale);
    },
    _itemNotAvailableForSale(item) {
      let _item_not_available_for_sale = false;

      if (this.freeGiftType === Types.Variant) {
        _item_not_available_for_sale = item.selectedVariant.availableForSale
          ? false
          : true;
      } else if (this.freeGiftType === Types.Product) {
        if (item.totalVariants === 1) {
          _item_not_available_for_sale = item.variants[0].availableForSale
            ? false
            : true;
        } else {
          _item_not_available_for_sale = item.variants.some(
            (variant) => variant.availableForSale
          )
            ? false
            : true;
        }
      }

      return _item_not_available_for_sale;
    },
    soldOut(item) {
      let _sold_out = false;

      if (item.totalVariants === 1) {
        _sold_out = item.variants[0].availableForSale ? false : true;
      } else {
        _sold_out = item.variants.some((variant) => variant.availableForSale)
          ? false
          : true;
      }

      return _sold_out;
    },
    async getFreeGiftData() {
      try {
        const { data } = await axios.get("/cart.js");
        return axios.post("/apps/nala-freegift/", {
          items: data.items,
          current_id: this.freeGiftCookie,
        });
      } catch (e) {
        console.log("getFreeGiftTypeData error: ", e);
      }
    },
    async acceptFreeGift(variant) {
      try {
        this._startLoading();
        if (this.freeGiftType === Types.Collection) {
          variant.loading = true;
        }
        await this.addFreeGiftToCart(variant);
        this._setFreeGiftCookie();
        this._cancelLoading();
        this._closeModal();
        this._refresh();
      } catch (e) {
        console.log("acceptFreeGift error: ", e);
      }
    },
    _setFreeGiftCookie() {
      this._setCookie("_free_gift_", this.freeGiftId, 1);
    },
    _setCookie(cName, value, days) {
      try {
        const expiresDate = new Date();
        expiresDate.setTime(expiresDate.getTime() + days * 24 * 60 * 60 * 1000);
        document.cookie = `${cName}=${value};expires=${expiresDate.toUTCString()}`;
      } catch (e) {
        console.log("setCookie error:", e);
      }
    },
    _getCookie(cName) {
      try {
        const name = cName + "=";
        const cDecoded = decodeURIComponent(document.cookie);
        const cArr = cDecoded.split("; ");
        let res;
        cArr.forEach((val) => {
          if (val.indexOf(name) === 0) res = val.substring(name.length);
        });
        return res;
      } catch (e) {
        console.log("getFreeGiftCookie error:", e);
      }
    },
    _cancelFreeGiftCookie() {
      return this._setFreeGiftCookie();
    },
    async denyFreeGift() {
      this._cancelFreeGiftCookie();
      this._closeModal();
      this._refresh();
    },
    deleteOldFreeGift() {
      if (this.old_line_id) {
        this.reload = true;
        return axios.post("/cart/change.js", {
          line: this.old_line_id,
          quantity: 0,
        });
      }
      return true;
    },
    addToCart(variant) {
      return axios.post("/cart/add.js", {
        items: [
          {
            id: variant.id,
            quantity: 1,
            properties: {
              _nala_special: "Yes",
              _nala_free_gift: "Yes",
              _nala_free_gift_message: this.freeGiftData.message,
            },
          },
        ],
      });
    },
    async addFreeGiftToCart(variant) {
      try {
        await this.addToCart(variant);
        this.reload = true;
      } catch (e) {
        console.log("addFreeGiftToCart error:", e);
      }
    },
    bindEvents() {
      // close modal with backgrop clicked:
      document.querySelector(".l-t4s-modal").addEventListener("click", (e) => {
        if (e.target === e.currentTarget) {
          this.denyFreeGift();
        }
      });

      document.addEventListener("cartUpdated", () => {
        this.checkFreeGift();
      });
    },
    onProductOptionChanged(evt, option) {
      const _selected_options_rest =
        this.freeGiftValues.selectedVariant.selectedOptions.find(
          (opt) => opt.name !== option.name
        );

      _targetSelectedOptions = !!_selected_options_rest
        ? [
            _selected_options_rest,
            {
              name: option.name,
              value: evt.target.value,
            },
          ]
        : [
            {
              name: option.name,
              value: evt.target.value,
            },
          ];

      this.freeGiftValues.selectedVariant = this.freeGiftValues.variants.find(
        (variant) => {
          return this._arrayDeepEqual(
            variant.selectedOptions,
            _targetSelectedOptions
          );
        }
      );
    },
    onProductVariantChanged(evt) {
      this.freeGiftValues.selectedVariant =
        this.freeGiftData.values.variants.find(
          (item) => item.id === evt.target.value
        );
    },
    onCollectionProductVariantChanged(product, evt) {
      this.freeGiftValues.products.forEach((item) => {
        if (item.id === product.id) {
          item.selectedVariant = item.variants.find(
            (el) => el.id === evt.target.value
          );
        }
      });
    },
    _refresh() {
      if (this.reload) {
        this.reload = false;
        location.reload();
      }
    },
    _showModal() {
      this.isActive = true;
    },
    _closeModal() {
      this.isActive = false;
    },
    _startLoading() {
      this.loading = true;
    },
    _cancelLoading() {
      this.loading = false;
    },
    _startFreeGiftLoader() {
      this.freeGiftLoader = true;
      document.querySelector("html").classList.add("l-loader-started");
    },
    _stopFreeGiftLoader() {
      this.freeGiftLoader = false;
      document.querySelector("html").classList.remove("l-loader-started");
    },
    _isNotPageRefreshOrReload() {
      const pageAccessedByReload =
        (window.performance.navigation &&
          window.performance.navigation.type === 1) ||
        window.performance
          .getEntriesByType("navigation")
          .map((nav) => nav.type)
          .includes("reload");
      return !pageAccessedByReload;
    },
  },
};

document.addEventListener("DOMContentLoaded", function () {
  Vue.createApp(freeGiftApp).mount("#freeGift");
});
